var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColLgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 29,
    viewBox: "0 0 4 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85266 0.66665H1.59983C0.904553 0.66665 0.340916 1.11815 0.340916 1.6751V27.3249C0.340916 27.8819 0.904553 28.3334 1.59983 28.3334H1.85266C2.54794 28.3334 3.11158 27.8819 3.11158 27.3249V1.6751C3.11158 1.11815 2.54794 0.66665 1.85266 0.66665Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColLgOwner);
export default __webpack_public_path__ + "static/media/col_lg_owner.b51ee7f223ee00d2f736ff3227febd51.svg";
export { ForwardRef as ReactComponent };